import http from './http';

export interface PetCarePreferencesData {
  id?: string;
  caretakerName: string;
  caretakerRelationship: string;
  caretakerPhone: string;
  caretakerEmail: string;
  alternateCaretakerName?: string;
  alternateCaretakerRelationship?: string;
  alternateCaretakerPhone?: string;
  alternateCaretakerEmail?: string;
  feedingInstructions?: string;
  medicationInstructions?: string;
  veterinarianName?: string;
  veterinarianPhone?: string;
  veterinarianAddress?: string;
  petInsuranceInfo?: string;
  specialInstructions?: string;
  notes?: string;
  lastUpdated?: string;
  isLocked?: boolean;
}

class PetCarePreferencesService {
  async createPetCarePreferences(data: Omit<PetCarePreferencesData, 'id'>): Promise<PetCarePreferencesData> {
    const response = await http.post('/api/pet-care-preferences', data);
    return response.data.data || response.data;
  }

  async updatePetCarePreferences(id: string, data: Partial<PetCarePreferencesData>): Promise<PetCarePreferencesData> {
    const response = await http.patch(`/api/pet-care-preferences/${id}`, data);
    return response.data.data || response.data;
  }

  async getPetCarePreferencesById(id: string): Promise<PetCarePreferencesData> {
    const response = await http.get(`/api/pet-care-preferences/${id}`);
    return response.data.data || response.data;
  }

  async getAllPetCarePreferences(): Promise<PetCarePreferencesData[]> {
    const response = await http.get('/api/pet-care-preferences');
    return response.data.data || response.data;
  }

  async deletePetCarePreferences(id: string): Promise<void> {
    await http.delete(`/api/pet-care-preferences/${id}`);
  }

  async lockPetCarePreferences(id: string): Promise<void> {
    await http.post(`/api/pet-care-preferences/${id}/lock`);
  }

  async unlockPetCarePreferences(id: string, emails: string[]): Promise<void> {
    await http.post(`/api/pet-care-preferences/${id}/unlock`, { emails });
  }

  async getPetCarePreferencesAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/pet-care-preferences/${id}/access-grants`);
    return response.data.data || response.data;
  }
}

export const petCarePreferencesService = new PetCarePreferencesService();